import React, { useState } from "react";
import AuthLayout from "layouts/AuthLayout";
import { AppInput, Button } from "components";
import styled from "styled-components";
import { ApiService } from "services";
import { toast } from "react-hot-toast";
const ForgotPassword = () => {
  const [email, setEmail] = useState();
  const [loader, setLoader] = useState(false);
  const sendEmail = async () => {
    setLoader(true);
    try {
      const data = await ApiService.forgotPasswordMail(email);
      console.log(data);
      setLoader(false);
      toast.success(data?.message || "Password change link sent to your mail");
    } catch (err) {
      if (err?.message === "It's not you, it's us. Try again later.") {
      } else if (err?.message === "Network Error") {
        return;
      } else {
        toast.error(err?.response?.data?.message || err?.message);
      }
      setLoader(false);
    }
  };
  return (
    <div>
      <AuthLayout
        submit={(e) => {
          e.preventDefault();
          console.log("eeee");
          sendEmail();
        }}
        title="Forgot Password"
      >
        <Emailinput>
          Please enter your email address and a reset link will be sent to the
          email provided
        </Emailinput>
        <AppInput
          onChange={(e) => {
            setEmail(e.target.value);
          }}
          placeholder="Enter your Email"
        />
        <Button disabled={loader} loading={loader} placeholder="Proceed" />
      </AuthLayout>
    </div>
  );
};

export default ForgotPassword;
const Emailinput = styled.p`
  display: flex;
  justify-content: center;
`;
